// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"6a10122a","299":"be34c689","355":"2866026f","890":"90246681","948":"44be8467"}[chunkId] + ".chunk.js";
};